import { Outlet } from 'react-router'
import { OrgLevelPermissions, useOrgInfo } from 'shared-ui/active-operation'
import { Forbidden403, Loading } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'
import { isNil } from 'utils'

export const CanManageOrSupportOrgGuard: React.FC = () => {
  const orgInfo = useOrgInfo()
  const { t } = useLocalization()

  // canUserManageOrg is false by default, so we have to wait for the orgInfo
  // to ensure that the permissions have actually loaded.
  if (isNil(orgInfo)) {
    return <Loading />
  }

  if (!(OrgLevelPermissions.canManage(orgInfo) || OrgLevelPermissions.isSupporter(orgInfo))) {
    return (
      <Forbidden403
        message={t(($) => $['only-org-managers'], {
          ownerEmail: orgInfo.ownerEmail
        })}
      />
    )
  }

  return <Outlet />
}
